import { render, staticRenderFns } from "./driverPromote.vue?vue&type=template&id=c740bd2a&scoped=true&"
import script from "./driverPromote.vue?vue&type=script&lang=js&"
export * from "./driverPromote.vue?vue&type=script&lang=js&"
import style0 from "./driverPromote.vue?vue&type=style&index=0&id=c740bd2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c740bd2a",
  null
  
)

export default component.exports